// RUT formatting utilities
export const formatRUT = (value: string) => {
  let regex2;
  let regex1;
  if (value.length >= 2) {
    regex1 = /[^0-9]/g;
    regex2 = /[^0-9k]/g;
    const valueToVerify = value.slice(0, -1).replace(regex1, '');
    const verifyingDigit = value.charAt(value.length - 1).replace(regex2, '');
    const cleanValue = valueToVerify + verifyingDigit;
    return `${cleanValue.slice(0, -1)}-${cleanValue.charAt(
      cleanValue.length - 1
    )}`;
  }
  return value;
};

export const calculateRUTDigit = (T: number) => {
  let M = 0;
  let S = 1;
  // eslint-disable-next-line no-param-reassign
  for (; T; T = Math.floor(T / 10)) {
    S = (S + (T % 10) * (9 - (M % 6))) % 11;
    M += 1;
  }
  return S ? S - 1 : 'k';
};

// Phone formatting utilities
export const formatPhoneNumber = (phone: string) => {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length >= 3) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 7)} ${cleaned.slice(
      7,
      11
    )}`;
  }
  return cleaned;
};

// Date formatting utilities
export const formatDate = (date: Date | string | null): string => {
  if (!date) return '';

  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toISOString().split('T')[0];
};
